import { applySegmentColor } from './apply-segment-color.js';
import { BaseReturnType } from '../../../core/color-rule/types.js';
import {
  ColorPalette,
  CustomColorPalette,
} from '../../../core/types/color-palette.js';
import { MultiMeterBarSegmentProps } from '../types/multi-meter-bar-chart.js';

export const getSegmentColor = (
  segment: MultiMeterBarSegmentProps,
  colorPalette: ColorPalette | CustomColorPalette,
  index: number,
  colorByRule: BaseReturnType,
) => {
  return (
    colorByRule?.Default ??
    segment.color ??
    applySegmentColor(segment.name, index, colorPalette, segment.color)
  );
};
